'use client'

import Link from 'next/link'

import sendEventToAnalytics from '@lib/helpers/client/send-event-to-analytics'

export type JobAdditionalDescriptionProps = {
  additionalDescription?: string | null
}

const JobAdditionalDescription = ({ additionalDescription }: JobAdditionalDescriptionProps): JSX.Element => {
  // FIXME: we assume that in the additionalDescription there is at maximum one link. We should change the logic if there could be more links.
  let preLink,
    linkUrl,
    linkContent,
    postLink: string | undefined = undefined

  const linkRegex = /^(.*?)<a\b([^>]*)>(.*?)<\/a>(.*)$/i

  const match = additionalDescription?.match(linkRegex)

  if (match) {
    preLink = match[1]
    const tagAttributes = match[2]
    linkContent = match[3]
    postLink = match[4]

    const hrefMatch = tagAttributes.match(/href=["'](.*?)["']/i)
    linkUrl = hrefMatch ? hrefMatch[1] : null
  }

  return (
    <>
      {additionalDescription ? (
        <p>
          <br />
          <hr />
          <br />
          {linkUrl ? (
            <>
              {preLink}
              <Link
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={(): Promise<void> => sendEventToAnalytics('job description link', { URL: linkUrl })}
              >
                {linkContent}
              </Link>
              {postLink}
            </>
          ) : (
            additionalDescription
          )}
        </p>
      ) : undefined}
    </>
  )
}

export default JobAdditionalDescription
